module.exports = __webpack_public_path__ + "static/media/sun-dust.95acac75.svg";